import React from "react";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";

export default function InputPassword({ name, validation }) {
  const { register } = useFormContext();

  return (
    <input
      type="password"
      name={name}
      className="form-control"
      ref={register(validation)}
    />
  );
}

InputPassword.propTypes = {
  name: PropTypes.string.isRequired,
  validation: PropTypes.object.isRequired,
};
